<template>
  <div id="dwv">
    <!-- // TODO ส่วนสำหรับแสดง Image -->
    <div class="image">
      <div class="layerGroup" id="view-image"></div>
    </div>

    <div v-if="!dataLoaded" class="loading">
      <loading style="width: 50px"></loading>
    </div>
    <!-- show data in image -->
    <div class="no-select">
      <div v-show="textDwv">
        <!-- element position -->
        <div class="position ma-3 success--text">
          <!-- Image : {{ ImageUid }} <br /> -->
          Position : {{ position[0] }} , {{ position[1] }} , {{ position[2]
          }}<br />
          Value : {{ valuePos }}<br />
          Window-center : {{ windowlevel.center }}<br />
          Window-width : {{ windowlevel.width }}<br />
        </div>
        <!-- element -->

        <div class="el-right">
          <div class="ma-3 mt-10 success--text">
            {{ CurrentWindowPresetName }} : WindowPresetName<br />
            {{ colorMap }} : ColorMap<br />
          </div>
        </div>
      </div>
      <div class="sub-right ma-2 d-flex">
        <v-btn color="primary rounded-pill" @click="textDwv = !textDwv">
          <v-icon>{{ textDwv ? "mdi-eye" : "mdi-eye-off-outline" }}</v-icon>
        </v-btn>
        <dwv-help v-model="setHelp"></dwv-help>
      </div>
    </div>

    <!-- // TODO ส่วนสำหรับ Tools ในการปรับแต่ง -->
    <div class="tools-items" v-if="dataLoaded">
      <div class="item-btn">
        <div
          class="px-1"
          v-for="item in getToolObject(toolsActive)"
          :key="item.name"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="['button', 'dialog'].includes(item.type)"
                v-bind="attrs"
                v-on="on"
                @click="onConfigTool(item)"
                :disabled="
                  currentTool.name == item.name && item.disableOnActive
                "
                :color="currentTool.name == item.name ? 'warning' : 'primary'"
                fab
                small
              >
                <!-- {{ item.name }} -->

                <v-icon>{{ item.icon }}</v-icon>
              </v-btn>
              <v-select
                v-if="item.type == 'selector'"
                v-model="item.value"
                :items="item.items"
                @input="onConfigTool(item)"
                :label="item.name"
                color="primary"
                dense
                solo
                hide-details
                style="width: 120px"
                :menu-props="{ top: true, offsetY: true }"
              >
              </v-select>
            </template>
            <span>{{ item.description }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <dwv-tag
      v-model="currentStateDialogTag"
      :meta-data="currentMetaDataDicom"
    ></dwv-tag>
  </div>
</template>
<style lang="css" scoped>
.loading {
  /* background: green; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: 100%;
  max-height: 100%;
  /* width: auto; */
  /* height: 300px !important; */
  object-fit: contain;
}
#dwv {
  /* width: 100vw; */
  /* height: 100vh; */
  width: 100%;
  height: 100%;
  background-color: red;
  /* padding: 1rem; */
  position: relative;
  top: 0;
  left: 0;
}
.no-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* .input {
  background-color: green;
  width: 100%;
  height: 80px;
  /* position: relative;
  top: 0;
  left: 0;
} */
.image {
  width: 100%;
  /* height: calc(100% - 160px); */
  height: 100%;
  /* background-color: #000; */
  background-color: purple;
  position: absolute;
  top: 0;
  left: 0;
}

/* #view-image {
  position: absolute;
  top: 0;
  left: 0;
} */

.action-btn {
  margin: 0.2rem;
}
.position {
  position: absolute;
  padding: 10px;
}
.el-right {
  text-align: right;
  position: absolute;
  top: 50;
  right: 0;
  padding: 10px;
}
.sub-right {
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
}
.tools-items {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  /* background-color: green; */
}
.tools-items .item-btn {
  display: flex;
  flex-wrap: nowrap;
  padding: 0.5rem;
  border-radius: 1rem;
  background-color: #808080;
}
.tools {
  /* width: 100%; */
  /* height: 80px; */
  padding: 0.5rem;
  border-radius: 1rem;
  background-color: #808080;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
}
.cm {
  margin-left: 3px;
  width: 150px;
  height: 10px;
  border-radius: 5%;
}
.wl {
  margin-left: 3px;
  width: 150px;
  height: 10px;
  border-radius: 5%;
}
.layerGroup {
  position: relative;
  padding: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #000;
}
/* ::v-deep .layer {
  position: relative !important;
  pointer-events: none;
  top: 0;
  left: 0;
} */
</style>
<style>
.layer {
  position: absolute;
  pointer-events: none;
}

.layer canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}
</style>
<script>
import loading from '@/components/loading.vue'
import dwvTag from '@/components/Forms/DialogTagDicom.vue'
import dwvHelp from '@/components/Forms/DialogHelp.vue'
import {
  App,
  AppOptions,
  ViewConfig,
  ToolConfig,
  getDwvVersion,
  decoderScripts,
  Index,
  logger
} from 'dwv'

import Vue from 'vue'

// Image decoders (for web workers)
decoderScripts.jpeg2000 = `${window.location.origin}/decoders/pdfjs/decode-jpeg2000.js`
decoderScripts[
  'jpeg-lossless'
] = `${window.location.origin}/decoders/rii-mango/decode-jpegloss.js`
decoderScripts[
  'jpeg-baseline'
] = `${window.location.origin}/decoders/pdfjs/decode-jpegbaseline.js`
decoderScripts.rle = `${window.location.origin}/decoders/dwv/decode-rle.js`
logger.level = logger.levels.ERROR

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    annotation: {
      type: Object,
      default: () => {}
    },
    activeTools: {
      type: Array,
      default: () => [
        'scroll',
        'zoomandpan',
        // 'windowlevel',
        'side',
        'reset',
        'cm',
        'wl',
        'drawrect',
        'drawellipse',
        'drawruler',
        'drawcircle',
        'info'
      ]
    }
  },
  components: {
    loading,
    dwvTag,
    dwvHelp
  },
  computed: {
    items: {
      get () {
        return this.value
      },
      set (n) {
        this.$emit('input', n)
        return n
      }
    },
    annotationString: {
      get () {
        if (this.annotation === null || this.annotation === undefined) {
          return ''
        } else return JSON.stringify(this.annotation)
      },
      set (v) {
        const x = JSON.stringify(v)
        if (this.dwvApp) this.dwvApp.applyJsonState(x)
        return x
      }
      // console.log('RUN')
      // if (this.annotation === null || this.annotation === undefined) return ''
      // else return JSON.stringify(this.annotation)
    }
  },

  data () {
    return {
      textDwv: true,
      setHelp: false,
      currentStateDialogTag: false,
      currentMetaDataDicom: null,

      // NOTE ข้อมูล list ทั้งหมดของ Tool
      toolsObject: [
        {
          name: 'scroll',
          description: 'Scroll',
          tool: 'Scroll',
          shape: '',
          icon: 'mdi-mouse-move-vertical',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: '', // NOTE ใช้กับ type selector
          status: false //  NOTE ใช้กับ Type Dialog
        },
        {
          name: 'zoomandpan',
          description: 'ZoomAndPan',
          tool: 'ZoomAndPan',
          shape: '',
          icon: 'mdi-magnify',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: '',
          status: false
        },
        {
          name: 'windowlevel',
          description: 'window level',
          tool: 'WindowLevel',
          shape: '',
          icon: 'mdi-contrast-circle',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: '',
          status: false
        },
        {
          name: 'side',
          description: 'side',
          tool: '',
          shape: '',
          icon: 'mdi-autorenew',
          disableOnActive: false,
          type: 'button',
          items: [],
          value: '',
          status: false
        },
        {
          name: 'reset',
          description: 'reset',
          tool: '',
          shape: '',
          icon: 'mdi-undo-variant',
          disableOnActive: false,
          type: 'button',
          items: [],
          value: '',
          status: false
        },

        {
          name: 'drawrect',
          description: 'draw rect',
          tool: 'Draw',
          shape: 'Rectangle',
          icon: 'mdi-shape-rectangle-plus',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: '',
          status: false
        },
        {
          name: 'drawellipse',
          description: 'draw ellipse',
          tool: 'Draw',
          shape: 'Ellipse',
          icon: 'mdi-ellipse-outline',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: '',
          status: false
        },

        {
          name: 'drawcircle',
          description: 'draw circle',
          tool: 'Draw',
          shape: 'Circle',
          icon: 'mdi-circle-outline',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'drawarrow',
          description: 'draw arrow',
          tool: 'Draw',
          shape: 'Arrow',
          icon: 'mdi-arrow-top-right-thin',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'drawprotractor',
          description: 'draw protractor',
          tool: 'Draw',
          shape: 'Protractor',
          icon: 'mdi-angle-acute',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'drawroi',
          description: 'draw roi',
          tool: 'Draw',
          shape: 'Roi',
          icon: 'mdi-dots-circle',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'drawfreehand',
          description: 'draw free hand',
          tool: 'Draw',
          shape: 'FreeHand',
          icon: 'mdi-draw',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'drawruler',
          description: 'draw ruler',
          tool: 'Draw',
          shape: 'Ruler',
          icon: 'mdi-pencil-ruler-outline',
          disableOnActive: true,
          type: 'button',
          items: [],
          value: ''
        },
        {
          name: 'cm',
          description: 'cm',
          tool: '',
          shape: '',
          icon: '',
          disableOnActive: false,
          type: 'selector',
          items: [
            'plain',
            'rainbow',
            'invPlain',
            'hot',
            'hot_iron',
            'pet',
            'hot_metal_blue',
            'pet_20step'
          ],
          value: 'plain'
        },
        {
          name: 'wl',
          description: 'wl',
          tool: '',
          shape: '',
          icon: '',
          disableOnActive: false,
          type: 'selector',
          items: ['Default0', 'mediastinum', 'lung', 'bone', 'brain', 'head'],
          value: 'Default0'
        },
        {
          name: 'info',
          description: 'info',
          tool: '',
          shape: '',
          icon: 'mdi-information-outline',
          disableOnActive: false,
          type: 'dialog',
          items: [],
          value: '',
          status: false
        }
      ],

      // NOTE เครื่องมือที่ได้ทำการเลือก
      currentTool: {
        name: 'scroll',
        description: 'Scroll',
        tool: 'Scroll',
        shape: '',
        icon: '',
        disableOnActive: true
      },

      // NOTE สำหรับดึง Version ของ dwv และ vue ที่ใช้งาน
      versions: {
        dwv: getDwvVersion(),
        vue: Vue.version
      },

      // // NOTE ไฟล์ที่มีการ Upload เข้ามาใช้งาน
      files: [],

      // NOTE Tools ที่สามารถใช้งานได้,
      // tt: {},
      tools: {
        Scroll: new ToolConfig(),
        ZoomAndPan: new ToolConfig(),
        WindowLevel: new ToolConfig(),
        // Draw: new ToolConfig(['Ruler'])
        Draw: new ToolConfig([
          'Arrow',
          'Ruler',
          'Circle',
          'Ellipse',
          'Rectangle',
          'Protractor',
          'Roi',
          'FreeHand'
        ])
      },

      // NOTE สำหรับเก็บ Object ของ dwv ที่ Instance ขึ้นมาใช้งาน
      dwvApp: null,
      allLayerGroupDivIds: null,
      // NOTE จำนวน Items ทั้งหมดที่มีการ Load
      nLoadItem: null,

      nReceivedLoadError: null,
      nReceivedLoadAbort: null,
      isFirstRender: null,
      dataLoaded: false,
      orientation: undefined,
      currentIndex: null,
      position: [0, 0, 0],
      valuePos: 0,
      ImageUid: '',
      windowlevel: 0,
      CurrentWindowPresetName: '',
      colorMap: '',
      isAnnotationChanging: false,
      toolsActive: []
    }
  },

  methods: {
    applyJsonState (val) {
      const jsonVal = JSON.stringify(val)
      this.dwvApp.applyJsonState(jsonVal)
    },
    deleteDraws () {
      this.dwvApp.getActiveLayerGroup().getActiveDrawLayer().deleteDraws()
    },
    onResize () {
      const container = document.getElementById('dwv')
      if (
        container &&
        container.offsetWidth > 0 &&
        container.offsetHeight > 0
      ) {
        this.dwvApp.fitToContainer()
      }
    },
    // NOTE เป็น Function สำหรับเมื่อมีการ Upload File
    // onInputFile (event) {
    //   // this.files = event
    //   this.dwvApp.loadFiles(event)
    // },

    // [x] PASS
    // NOTE เป็น Function สำหรับดึง Object
    getToolObject (tools = []) {
      return this.toolsObject.filter((e) => tools.includes(e.name))
    },

    // [x] PASS
    onConfigTool (element = {}, options = {}) {
      // NOTE ส่วนสำหรับ ปั่น ITEMS TOOL

      // NOTE สำหรับ Set Toot ปัจจุบันที่ใช้งาน
      if (!['cm', 'wl', 'info'].includes(element.name)) {
        this.currentTool = element
      }

      // let dataViewConfigs
      // let allLayerGroupDivIds
      // const lgIds = null
      let curentValueCMWL = []

      // NOTE Active Tools
      switch (element.name) {
        // [x] PASS
        case 'scroll':
          this.dwvApp.setTool(element.tool)
          break

        // [x] PASS
        case 'zoomandpan':
          this.dwvApp.setTool(element.tool)
          break

        // [x] PASS
        case 'windowlevel':
          this.dwvApp.setTool(element.tool)
          break

        // [x] PASS
        case 'side':
          this.toggleOrientation()

          // TODO Get Last Config
          curentValueCMWL = this.toolsObject
            .filter((e) => ['wl', 'cm'].includes(e.name))
            .reduce((acc, e) => {
              acc[e.name] = e.value
              return acc
            }, {})
          this.dwvApp.setColourMap(curentValueCMWL.cm)
          this.setWindowWidthAndLevel(curentValueCMWL.wl)
          break

        // [x] PASS
        case 'reset':
          // NOTE แก้ไข Bug เมื่อกด Reset แล้วปุ่มเปลี่ยนสี
          this.currentTool = {}

          // NOTE Reset value CM & WL in state
          this.toolsObject = this.toolsObject.map((e) => {
            switch (e.name) {
              case 'cm':
                e.value = 'plain'
                break
              case 'wl':
                e.value = 'Default0'
                break
            }
            return e
          })

          // NOTE แก้ไข BUG เมื่อค้าง Tool ตัวอื่นอยู่
          this.dwvApp.setTool('Scroll')

          this.onReset()
          break

        // [] PASS
        case 'cm':
          this.dwvApp.setColourMap(element.value)
          break

        // [] PASS
        case 'wl':
          this.setWindowWidthAndLevel(element.value)
          break

        // [x] PASS
        case 'drawcircle':
        case 'drawruler':
        case 'drawellipse':
        case 'drawrect':
        case 'drawarrow':
        case 'drawprotractor':
        case 'drawroi':
        case 'drawfreehand':
          this.dwvApp.setTool(element.tool)
          this.onChangeShape(element.shape)
          break

        case 'info':
          // NOTE แก้ไข Bug เมื่อกด Reset แล้วปุ่มเปลี่ยนสี
          // this.currentTool = {}

          // NOTE สั่งเปิด Dialog
          this.currentStateDialogTag = true

          this.currentMetaDataDicom = this.dwvApp.getMetaData(0)
          break

        default:
          break
      }
    },

    // NOTE เป็น function สำหรับการเลือกรูปแบบของ การวาด
    onChangeShape (shape) {
      if (this.dwvApp && this.currentTool.tool === 'Draw') {
        this.dwvApp.setToolFeatures({ shapeName: shape })
      }
    },

    // NOTE Function สำหรับการ Reset
    onReset () {
      this.dwvApp.setColourMap('plain')
      this.dwvApp.resetDisplay()
    },
    setWindowWidthAndLevel (val) {
      const dataViewConfigs = this.dwvApp.getDataViewConfigs()
      const allLayerGroupDivIds = this.getLayerGroupDivIds(dataViewConfigs)
      const lgIds = allLayerGroupDivIds
      for (let i = 0; i < lgIds.length; ++i) {
        const lg = this.dwvApp.getLayerGroupByDivId(lgIds[i])
        const vl = lg.getActiveViewLayer()
        if (typeof vl !== 'undefined') {
          const vc = vl.getViewController()
          vc.setWindowLevelPreset(val)
        }
      }
    },

    // NOTE Function สำหรับการปรับมุมมอง
    toggleOrientation () {
      if (typeof this.orientation !== 'undefined') {
        if (this.orientation === 'axial') {
          this.orientation = 'coronal'
        } else if (this.orientation === 'coronal') {
          this.orientation = 'sagittal'
        } else if (this.orientation === 'sagittal') {
          this.orientation = 'axial'
        }
      } else {
        // default is most probably axial
        this.orientation = 'coronal'
      }
      // update data view config
      const viewConfig0 = new ViewConfig('view-image')
      viewConfig0.orientation = this.orientation
      const viewConfigs = { '*': [viewConfig0] }
      this.dwvApp.setDataViewConfigs(viewConfigs)
      // render data
      for (let i = 0; i < this.files.length; ++i) {
        this.dwvApp.render(i)
      }
    },

    getLayerGroupDivIds (dataViewConfigs) {
      const divIds = []
      const keys = Object.keys(dataViewConfigs)
      for (let i = 0; i < keys.length; ++i) {
        const dataViewConfig = dataViewConfigs[keys[i]]
        for (let j = 0; j < dataViewConfig.length; ++j) {
          const divId = dataViewConfig[j].divId
          if (!divIds.includes(divId)) {
            divIds.push(divId)
          }
        }
      }
      return divIds
    },

    create () {
      // this.currentTool = this.getToolObject(this.activeTools)[0]
      this.currentTool = {}
      const t = this.getToolObject(this.toolsActive)
      if (t.length > 0) this.currentTool = t[0]

      // NOTE Create dwv app
      this.dwvApp = new App()

      // initial app
      // NOTE get element show image
      const viewConfig0 = new ViewConfig('view-image')

      // NOTE Create object conform viewConfig format
      const viewConfigs = { '*': [viewConfig0] }

      // NOTE Create New Object AppOption from viewConfigs
      const options = new AppOptions(viewConfigs)

      // NOTE Ad tools to Options
      options.tools = this.tools

      // NOTE set option to dwvApp
      this.dwvApp.init(options)

      // Event listeners for DWV
      this.setupEventListener()

      setTimeout(() => {
        const dataViewConfigs = this.dwvApp.getDataViewConfigs()

        this.allLayerGroupDivIds = this.getLayerGroupDivIds(dataViewConfigs)

        // this.dwvApp.loadFiles(this.files)

        this.dwvApp.loadURLs(this.files)
      }, 3000)
    },

    setupEventListener () {
      // this.dwvApp.addEventListener('loadprogress', function (event) {
      //   console.log('Load Progress:', event.loaded / event.total * 100, '%')
      // })

      this.dwvApp.addEventListener('error', function (event) {
        console.error('Load Error:', event)
      })

      // this.dwvApp.addEventListener('loaderror', function (event) {
      //   console.error('Load Error:', event)
      // })

      // NOTE handle load events
      this.dwvApp.addEventListener('loadstart', (event) => {
        this.colorMap = 'plain'
        console.time('load-data-' + event.dataid)
        // console.log('loadstart')
        // reset flags
        this.dataLoaded = false
        this.nLoadItem = 0
        this.nReceivedLoadError = 0
        this.nReceivedLoadAbort = 0
        this.isFirstRender = true
      })

      // NOTE handle load events
      this.dwvApp.addEventListener('load', (/* event */) => {
        // set dicom tags
        // console.log('load', e)
        // const meta = this.dwvApp.getMetaData(0)
        // set data loaded flag
      })

      this.dwvApp.addEventListener('positionchange', (e) => {
        // console.log('positionchange', e)
        this.position = e.value[0]
        this.valuePos = e.value[2]
        this.ImageUid = e.data.imageUid
        // console.log(e.data.imageUid)
      })

      // NOTE handle load events
      this.dwvApp.addEventListener('loadend', (event) => {
        const meta = this.dwvApp.getMetaData(event.dataid)
        const metaName = this.getMetaDataWithNames(meta)
        this.toolsActive = this.activeTools
        // ตรวจสอบการมีอยู่ของ WindowWidth และ WindowCenter
        if (!metaName?.WindowCenter || !metaName?.WindowWidth) {
          this.toolsActive = this.activeTools.filter(
            (tool) => tool !== 'cm' && tool !== 'wl' && tool !== 'windowlevel'
          )
        } else {
          this.windowlevel.center = metaName?.WindowCenter.value[0]
          this.windowlevel.width = metaName.WindowWidth.value[0]
        }

        // TODO สำหรับการ Load object เข้าไปใช้งาน
        if (this.annotationString !== '') {
          this.dwvApp.applyJsonState(this.annotationString)
        }

        this.dataLoaded = true
        if (this.nReceivedLoadError) {
          this.loadProgress = 0
          alert('Received errors during load. Check log for details.')
        }
        if (this.nReceivedLoadAbort) {
          this.loadProgress = 0
          alert('Load was aborted.')
        }
      })

      // NOTE handle load events
      this.dwvApp.addEventListener('renderend', (event) => {
        // console.log(this.dwvApp.getNumberOfLayerGroups())
        if (this.isFirstRender) {
          this.isFirstRender = false
          // available tools
          const selectedTool = 'ZoomAndPan'
          this.dwvApp.setTool(selectedTool)
          if (this.dwvApp.canScroll()) {
            this.dwvApp.setTool('Scroll')
          }
          // this.onChangeTool(selectedTool)
        }
      })

      // handle key events
      this.dwvApp.addEventListener('keydown', (event) => {
        // console.log('keydown')
        this.dwvApp.defaultOnKeydown(event)
        const layerGroup = this.dwvApp.getActiveLayerGroup()
        const viewController = layerGroup
          .getActiveViewLayer()
          .getViewController()
        const position = this.position
        const key = event.key

        const updatePosition = (newIndex) => {
          if (newIndex >= 0 && newIndex < this.files.length) {
            position[2] = newIndex
            viewController.setCurrentIndex(new Index(position))
          }
        }

        switch (key) {
          case 'ArrowUp':
          case 'ArrowRight':
            updatePosition(position[2] + 1)
            break
          case 'ArrowDown':
          case 'ArrowLeft':
            updatePosition(position[2] - 1)
            break
          default:
            // this.getValue()
            break
        }
      })
      // this.dwvApp.addEventListener('zoomchange', function (event) {
      //   console.log('Zoom Change:', event)
      // })

      // this.dwvApp.addEventListener('windowingchange', function (event) {
      //   console.log('Windowing Change:', event)
      // })

      // NOTE Event Handler เมื่อมีการ Create Draw
      this.dwvApp.addEventListener('drawcreate', (event) => {
        this.getJsonState()
        // console.log('Draw Create:', event)
      })

      // NOTE Event Handler เมื่อมีการ Edit Draw
      this.dwvApp.addEventListener('drawchange', (event) => {
        this.getJsonState()
        // console.log('Draw Change:', event)
      })

      // NOTE Event Handler เมื่อมีการ Delete Draw
      this.dwvApp.addEventListener('drawdelete', (event) => {
        this.getJsonState()
        // console.log('Draw Delete:', event)
      })

      // this.dwvApp.addEventListener('toolchange', function (event) {
      //   console.log('Tool Change:', event)
      // })

      // this.dwvApp.addEventListener('slicechange', function (event) {
      //   console.log('Slice Change:', event)
      // })
      this.dwvApp.addEventListener('wlchange', (e) => {
        // console.log('wlchange', e)
        this.CurrentWindowPresetName = e.value[2]
        this.windowlevel = {
          center: e.value[0],
          width: e.value[1]
        }
      })
      this.dwvApp.addEventListener('colourmapchange', (e) => {
        this.colorMap = e.value[0]
      })

      window.addEventListener('resize', this.onResize)
    },

    // randomIntFromInterval (min, max) { // min and max included
    //   const x = Math.floor(Math.random() * (max - min + 1) + min)
    //   return x
    // },

    // NOTE เป็น Function สำหรับการ Remove Element สำหรับการดูภาพ Dicom
    remove () {
      // TODO Remove Event Listener
      if (this.dwvApp != null) {
        window.removeEventListener('resize', this.onResize)
      }
      // TODO Remove Element
      if (document.getElementById('view-image')) {
        document.getElementById('view-image').innerHTML = ''
      }
      // TODO Set Default Variable
      this.dwvApp = null
      this.dataLoaded = false
      this.files = []
    },

    defaultPresetsCm (item) {
      this.dwvApp.setColourMap(item)
    },

    defaultPresets (item) {
      this.allLayerGroupDivIds.forEach((divId) => {
        const layerGroup = this.dwvApp.getLayerGroupByDivId(divId)
        const viewLayer = layerGroup.getActiveViewLayer()
        if (viewLayer) {
          const viewController = viewLayer.getViewController()
          viewController.setWindowLevelPreset(item)
        }
      })
    },

    // [x] PASS
    // NOTE เป็น Function สำหรับการแกะค่าและ Mapping ค่า URLs ตาม Document
    // NOTE จาก Items ที่โดยเข้ามาใน Component
    getUrlFromItems (items) {
      return items.map((element) => {
        let url = element.src

        // TODO Check for DICOM-related fields
        // FIX : บาง image file เปิดไม่ได้ เนืองจาก บางไฟล์มี pn บางไฟล์ไม่มี
        // if (element.pn || element.po || element.da) {
        if (element.po || element.da) {
          url = this.dicomUrl(`${element.job_id}.dcm`)
        } else {
          // Extract the file name using regex
          const regex = /\/([^\\/?]+\.(jpg|jpeg|png|dcm))(\?.*)?$/i
          const match = url.match(regex)

          if (match) {
            const fileName = match[1]
            url = this.imageUrl(fileName)
          } else {
            console.warn('No valid file found in URL:', url)
          }
        }

        return url
      })
    },
    // [x] PASS
    // NOTE เป็น Function สำหรับ Get State ของข้อมูล
    // NOTE และจะทำการ Emit ข้อมูลไปยัง Parent
    getJsonState () {
      // TODO Get the JSON state and parse it
      const stateJson = JSON.parse(this.dwvApp.getJsonState())

      // TODO Filter out children with no children
      stateJson.drawings.children = stateJson.drawings.children.filter(
        (child) => child.children.length > 0
      )

      // TODO Emit value to parent
      this.$emit('updateDraw', stateJson)
      return stateJson
    }
  },
  watch: {
    // annotation: {
    //   deep: true,
    //   handler (n, o) {
    //     if (!this.isAnnotationChanging) {
    //       this.isAnnotationChanging = true

    //       if (o) {
    //         console.log('Deleting previous drawings...')
    //         this.dwvApp.getActiveLayerGroup().getActiveDrawLayer().deleteDraws()
    //       }
    //       this.$nextTick(() => {
    //         this.annotationString = n
    //         this.isAnnotationChanging = false
    //         console.log('Updated annotationString:', this.annotationString)
    //       })
    //     }
    //   }
    // },
    items: {
      deep: true,
      immediate: true,
      handler (n) {
        // TODO Reset Old Element
        this.remove()

        // TODO Get URL Data From items
        this.files = this.getUrlFromItems(n)

        if (n.length > 0) {
          // TODO get url image from items
          this.create()
        }
      }
    }
  }
}
</script>
